import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

export type PanelItemLayout = 'vertical' | 'horizontal';

export interface PanelItemProps {
  name?: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  control?: React.ReactNode;
  layout?: PanelItemLayout;
  disabled?: boolean;
  className?: string;
  headerClassName?: string;
  nameClassName?: string;
  descriptionClassName?: string;
  controlClassName?: string;
}

const LAYOUT_CLASS_MAP: Record<PanelItemLayout, string> = {
  vertical: styles.vertical,
  horizontal: styles.horizontal,
};

export default function PanelItem({
  name,
  description,
  children,
  control,
  layout = 'vertical',
  disabled = false,
  className,
  headerClassName,
  nameClassName,
  descriptionClassName,
  controlClassName,
}: PanelItemProps) {
  const content = control ?? children;
  const hasHeader = name !== undefined || description !== undefined;

  return (
    <div
      className={classNames(
        styles.item,
        LAYOUT_CLASS_MAP[layout],
        {
          [styles.disabled]: disabled,
        },
        className,
      )}
      data-layout={layout}
    >
      {hasHeader && (
        <div className={classNames(styles.header, headerClassName)}>
          {name !== undefined && (
            <div className={classNames(styles.name, nameClassName)}>{name}</div>
          )}
          {description !== undefined && (
            <div className={classNames(styles.description, descriptionClassName)}>
              {description}
            </div>
          )}
        </div>
      )}
      <div className={classNames(styles.control, controlClassName)}>{content}</div>
    </div>
  );
}
